import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Font,
  Svg,
  Path,
} from "@react-pdf/renderer";
import moment from "moment";

import hopeSkipDriveIcon from "../../Assets/hope-skip-drive.png";
import font from "../../font/Cairo-VariableFont_wght.ttf";
import boldFont from "../../font/Cairo-Bold.ttf";
import boldRobotoFont from "../../font/RobotoCondensed-Bold.ttf";
import RobotoFont from "../../font/Roboto-Bold.ttf";
import kalamFont from "../../font/Kalam-Light.ttf";
import "../../font/registerPatrickHandAndCaveatPdf";
import { handDrawnCirclePath, HAND_DRAWN_CIRCLE_VIEWBOX } from "../../utils/handDrawnCircle";

Font.register({ family: "kalamFont", format: "truetype", src: kalamFont });
Font.register({ family: "Cairo", format: "truetype", src: font });
Font.register({ family: "Cairo-Bold", format: "truetype", src: boldFont });
Font.register({ family: "RobotoCondensed-Bold", format: "truetype", src: boldRobotoFont });
Font.register({ family: "Roboto-Bold", format: "truetype", src: RobotoFont });

export const INSPECTION_POINTS = [
  "Foot Brakes",
  "Emergency Brakes",
  "Steering Mechanism",
  "Windshield",
  "Rear Window & Other Glass",
  "Windshield Wipers",
  "Headlights",
  "Tail Lights",
  "Turn Indicator Lights",
  "Stop Lights",
  "Front seat adjustment mechanism",
  "Doors (open, close, lock)",
  "Horn",
  "Speedometer",
  "Bumper",
  "Muffler and exhaust system",
  'Condition of tyres, including tread depth\nno less than 2/32"',
  "Interior and exterior rear view mirrors",
  "Safety belts for driver and passengers",
];

// SVG checkmark from Figma
export const HOP_RED_CHECK_PATH = "M35.4242 1.03706C36.1443 0.375137 37.1164 0.00260774 38.1303 1.36387e-05C39.1443 -0.00258046 40.1186 0.364969 40.8426 1.0232C41.5666 1.68143 41.9822 2.57746 41.9994 3.51756C42.0167 4.45766 41.6343 5.3663 40.9349 6.04703L20.3947 29.8563C20.0417 30.2089 19.6156 30.4918 19.1419 30.6882C18.6683 30.8847 18.1568 30.9905 17.6381 30.9994C17.1193 31.0083 16.6039 30.9201 16.1228 30.7401C15.6416 30.5601 15.2045 30.2919 14.8377 29.9517L1.22824 17.3266C0.849094 16.999 0.544993 16.6039 0.334075 16.1649C0.123157 15.726 0.00974274 15.2521 0.000600564 14.7716C-0.00854161 14.2911 0.0867754 13.8139 0.280863 13.3683C0.474951 12.9227 0.763835 12.5179 1.13028 12.1781C1.49673 11.8383 1.93323 11.5704 2.41374 11.3904C2.89425 11.2104 3.40894 11.122 3.92709 11.1305C4.44524 11.139 4.95625 11.2442 5.42961 11.4397C5.90298 11.6353 6.32902 11.9173 6.68231 12.2689L17.4567 22.2554L35.3265 1.14204C35.3584 1.10507 35.3927 1.07001 35.4294 1.03706H35.4242Z";
export const HOP_RED_CHECK_VIEWBOX = "0 0 42 31";

export const FIGMA_TO_PDF_SCALE = 792 / 1925; // 0.4114
const S = FIGMA_TO_PDF_SCALE;
const px = (n) => Number((n * S).toFixed(2));
const HORIZ_OFFSET = Number(((612 - 1440 * S) / 2).toFixed(2));

const buildPdfStyles = () => {
  return StyleSheet.create({
    page: {
      padding: 0,
      fontFamily: "Cairo",
    },
    body: {
      position: "relative",
      width: px(1440),
      height: px(1925),
      marginLeft: HORIZ_OFFSET,
    },
    logo: {
      position: "absolute",
      left: px(67),
      top: px(50),
      width: px(230),
      height: px(140),
      objectFit: "contain",
    },
    title: {
      position: "absolute",
      left: px(540),
      top: px(140),
      fontFamily: "Cairo",
      fontWeight: 500,
      fontSize: px(40),
      color: "#000000",
    },
    // Top Info Section
    infoRow: {
      position: "absolute",
      left: px(67),
      width: px(1306),
      flexDirection: "row",
      justifyContent: "space-between",
    },
    fieldLeft: {
      width: px(630),
      flexDirection: "row",
      alignItems: "flex-end",
    },
    fieldRight: {
      width: px(630),
      flexDirection: "row",
      alignItems: "flex-end",
    },
    label: {
      fontFamily: "Cairo",
      fontSize: px(26),
      color: "#000000",
      marginRight: px(10),
      marginBottom: px(-4),
    },
    valueBox: {
      flex: 1,
      height: px(40),
      backgroundColor: "#FFFF00",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingBottom: px(1),
      borderBottomWidth: px(1.5),
      borderBottomColor: "#000000",
      borderBottomStyle: "solid",
    },
    valueText: {
      fontFamily: "Roboto-Bold",
      fontSize: px(23),
      color: "#000000",
      marginBottom: px(-4),
    },
    signatureImg: {
      width: px(150),
      height: px(70),
      position: "absolute",
      bottom: px(-10),
      marginLeft: px(-20),
      objectFit: "contain",
    },
    
    // Result Section
    resultRow: {
      position: "absolute",
      top: px(530),
      width: "100%",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
    resultTitle: {
      fontFamily: "Cairo-Bold",
      fontSize: px(35),
      color: "#000000",
      marginRight: px(40),
    },
    resultPassFailContainer: {
      flexDirection: "row",
      alignItems: "center",
    },
    pfItem: {
      position: "relative",
      width: px(120),
      height: px(120),
      justifyContent: "center",
      alignItems: "center",
    },
    pfItemText: {
      fontFamily: "Cairo-Bold",
      fontSize: px(35),
      color: "#000000",
    },
    pfCircleSvg: {
      position: "absolute",
      width: px(120),
      height: px(90),
      left: 0,
      top: px(15),
    },

    // Table Section
    table: {
      position: "absolute",
      left: px(120),
      top: px(660),
      width: px(1200),
      borderWidth: px(1.5),
      borderColor: "#000000",
    },
    tableHeaderRow: {
      flexDirection: "row",
      height: px(60),
      borderBottomWidth: px(1.5),
      borderBottomColor: "#000000",
      alignItems: "center",
    },
    tableRow: {
      flexDirection: "row",
      height: px(58),
      borderBottomWidth: px(1.5),
      borderBottomColor: "#000000",
      alignItems: "center",
    },
    tableRowLast: {
      borderBottomWidth: 0,
    },
    col1: {
      width: px(480),
      borderRightWidth: px(1.5),
      borderRightColor: "#000000",
      height: "100%",
      justifyContent: "center",
      paddingLeft: px(20),
    },
    col2: {
      width: px(230),
      borderRightWidth: px(1.5),
      borderRightColor: "#000000",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    col3: {
      width: px(490),
      height: "100%",
      justifyContent: "center",
      paddingLeft: px(20),
    },
    thText: {
      fontFamily: "Cairo-Bold",
      fontSize: px(23),
      color: "#000000",
      textAlign: "center",
      width: "100%",
    },
    tdText: {
      fontFamily: "Cairo",
      fontSize: px(21),
      color: "#000000",
    },
    checkSvg: {
      width: px(42),
      height: px(31),
    }
  });
};

const formatDate = (dateString) => {
  if (!dateString) return " ";
  return moment(new Date(dateString)).format("MM/DD/YYYY");
};

const HopSkipDriveCertificateDownload = ({
  checksData,
  reportData,
  fileName,
  linkLabel,
  handwritingFont,
}) => {
  const styles = buildPdfStyles();
  const selectedFont = handwritingFont || "kalamFont";
  const handwritingStyle = { fontFamily: selectedFont };

  const hostName = reportData
    ? `${reportData?.Username?.toUpperCase() || ""} ${reportData?.UserlastName ? reportData.UserlastName.toUpperCase() : ""}`
    : " ";
  const carMakeModel = reportData
    ? `${reportData?.make?.toUpperCase() || ""} ${reportData?.model?.toUpperCase() || ""}`
    : " ";
  const carYearColor = reportData
    ? `${reportData?.year || ""}/${reportData?.color?.toUpperCase() || ""}`
    : " ";
  const vin = reportData?.vin?.toUpperCase() || " ";
  const licensePlate = reportData?.licensePlateNumber?.toUpperCase() || " ";
  const numSeats = reportData?.seats ? `0${reportData.seats - 1}` : " ";
  const inspectorSig = reportData?.Inspectorsignature;
  const finalStatus = reportData?.finalStatus;

  return (
    <div style={{ display: "inline-block" }}>
      <PDFDownloadLink
        document={
          <Document>
            <Page size="LETTER" style={styles.page}>
              <View style={styles.body} wrap={false}>
                <Image style={styles.logo} source={hopeSkipDriveIcon} />
                <Text style={styles.title}>Vehicle Inspection Form</Text>

                {/* Y = 290 */}
                <View style={[styles.infoRow, { top: px(250) }]}>
                  <View style={styles.fieldLeft}>
                    <Text style={styles.label}>Inspection Date</Text>
                    <View style={styles.valueBox}>
                      <Text style={[styles.valueText, handwritingStyle]}>{formatDate(reportData?.reviewedDate)}</Text>
                    </View>
                  </View>
                  <View style={styles.fieldRight}>
                    <Text style={styles.label}>Car Make/Model</Text>
                    <View style={styles.valueBox}>
                      <Text style={[styles.valueText, handwritingStyle]}>{carMakeModel}</Text>
                    </View>
                  </View>
                </View>

                {/* Y = 350 */}
                <View style={[styles.infoRow, { top: px(300) }]}>
                  <View style={styles.fieldLeft}>
                    <Text style={styles.label}>Name</Text>
                    <View style={styles.valueBox}>
                      <Text style={[styles.valueText, handwritingStyle]}>{hostName}</Text>
                    </View>
                  </View>
                  <View style={styles.fieldRight}>
                    <Text style={styles.label}>Car Year/Color</Text>
                    <View style={styles.valueBox}>
                      <Text style={[styles.valueText, handwritingStyle]}>{carYearColor}</Text>
                    </View>
                  </View>
                </View>

                {/* Y = 410 */}
                <View style={[styles.infoRow, { top: px(359) }]}>
                  <View style={styles.fieldLeft}>
                    <Text style={styles.label}>VIN</Text>
                    <View style={styles.valueBox}>
                      <Text style={[styles.valueText, handwritingStyle]}>{vin}</Text>
                    </View>
                  </View>
                  <View style={styles.fieldRight}>
                    <Text style={styles.label}># of seats (do not include driver)</Text>
                    <View style={styles.valueBox}>
                      <Text style={[styles.valueText, handwritingStyle]}>{numSeats}</Text>
                    </View>
                  </View>
                </View>

                {/* Y = 470 */}
                <View style={[styles.infoRow, { top: px(420) }]}>
                  <View style={styles.fieldLeft}>
                    <Text style={styles.label}>License Plate #</Text>
                    <View style={styles.valueBox}>
                      <Text style={[styles.valueText, handwritingStyle]}>{licensePlate}</Text>
                    </View>
                  </View>
                  <View style={styles.fieldRight}>
                    <Text style={styles.label}>Mechanic's Signature</Text>
                    <View style={[styles.valueBox, { backgroundColor: "transparent" }]}>
                      {inspectorSig ? (
                        <Image
                          style={styles.signatureImg}
                          source={{
                            uri: `${process.env.REACT_APP_AWS_S3_LINK}/${inspectorSig}?x-request=xhr`,
                            method: "GET",
                            headers: { "Cache-Control": "no-cache" },
                          }}
                        />
                      ) : null}
                    </View>
                  </View>
                </View>

                {/* Y = 530 */}
                <View style={[styles.infoRow, { top: px(480) }]}>
                  <View style={[styles.fieldLeft, { width: px(1306) }]}>
                    <Text style={[styles.label, { marginRight: px(25) }]}>Name of Facility Licensed by the Bureau of Automotive Repair:</Text>
                    <View style={[styles.valueBox, { backgroundColor: "transparent", alignItems: "flex-start", paddingLeft: px(65), marginBottom: px(7) }]}>
                      <Text style={[styles.valueText, handwritingStyle]}>Chex Inc.</Text>
                    </View>
                  </View>
                </View>

                {/* Result */}
                <View style={styles.resultRow}>
                  <Text style={styles.resultTitle}>Vehicle Inspection Result:</Text>
                  <View style={styles.resultPassFailContainer}>
                    <View style={styles.pfItem}>
                      {finalStatus === "pass" ? (
                        <Svg style={styles.pfCircleSvg} viewBox={HAND_DRAWN_CIRCLE_VIEWBOX} fill="none">
                          <Path
                            d={handDrawnCirclePath}
                            stroke="#FF0000"
                            strokeWidth={3}
                            strokeLinecap="round"
                            fill="none"
                          />
                        </Svg>
                      ) : null}
                      <Text style={styles.pfItemText}>PASS</Text>
                    </View>
                    <View style={[styles.pfItem, { marginLeft: px(40) }]}>
                      {finalStatus === "fail" ? (
                        <Svg style={styles.pfCircleSvg} viewBox={HAND_DRAWN_CIRCLE_VIEWBOX} fill="none">
                          <Path
                            d={handDrawnCirclePath}
                            stroke="#FF0000"
                            strokeWidth={3}
                            strokeLinecap="round"
                            fill="none"
                          />
                        </Svg>
                      ) : null}
                      <Text style={styles.pfItemText}>FAIL</Text>
                    </View>
                  </View>
                </View>

                {/* Table */}
                <View style={styles.table}>
                  <View style={styles.tableHeaderRow}>
                    <View style={styles.col1}>
                      <Text style={styles.thText}>Point of Inspection</Text>
                    </View>
                    <View style={styles.col2}>
                      <Text style={styles.thText}>Inspected</Text>
                    </View>
                    <View style={[styles.col3, { borderRightWidth: 0 }]}>
                      <Text style={styles.thText}>Comments</Text>
                    </View>
                  </View>
                  
                  {INSPECTION_POINTS.map((pt, idx) => {
                    const isLast = idx === INSPECTION_POINTS.length - 1;
                    const checkItem = (checksData || []).find((c) => c?.category_id === (idx + 1).toString() || c?.index === (idx + 1));
                    const actualStatus = checkItem ? checkItem.status : ((checksData || [])[idx]?.status);
                    const passed = actualStatus === "pass" || actualStatus === true || actualStatus === 1 || actualStatus === "1";
                    
                    return (
                      <View key={idx} style={[styles.tableRow, isLast ? styles.tableRowLast : {}, pt === "Bumper" ? { borderBottomWidth: px(3) } : {}, pt.startsWith("Condition of tyres") ? { height: px(88) } : {}]}>
                        <View style={styles.col1}>
                          <Text style={styles.tdText}>{pt}</Text>
                        </View>
                        <View style={styles.col2}>
                          {passed ? (
                            <Svg style={styles.checkSvg} viewBox={HOP_RED_CHECK_VIEWBOX} fill="none">
                              <Path d={HOP_RED_CHECK_PATH} fill="#EB5757" />
                            </Svg>
                          ) : null}
                        </View>
                        <View style={[styles.col3, { borderRightWidth: 0 }]}>
                          <Text style={styles.tdText}> </Text>
                        </View>
                      </View>
                    );
                  })}
                </View>

              </View>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                    cursor: "pointer",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
};

const HopSkipDriveCertificateDownloadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "template2");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <HopSkipDriveCertificateDownload
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.vehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setOtherReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HopSkipDriveCertificateDownloadConnected);
